$( document ).ready(function() {
  'use strict';
  $('.wysiwyg-community-info').addClass('active');
});
